<template>
  <div id="app">
      <router-view v-wechat-title="$route.meta.title"></router-view>
  </div>
</template>

<script>
export default {
    data () {
      return {

      }
    }
}
</script>
<style lang="less" scoped>
    #app{
        height: 100%;
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// ./src/App.vue